import React from 'react';
import { capitalize } from 'lodash';
import { StyledTag } from 'components/new-ui/base/tag/styles';
import Button from 'components/new-ui/base/button/Button';
import { FilterTag, ListManifestsParamKeys } from '../hooks/useManifestsFilters';
import useManifestFilterLabels from '../hooks/useManifestFilterLabels';

type Props = {
    tags: FilterTag[];
    ownerId?: string;
    teamId?: string;
    createdBy?: string;
    onClearTag: (key: string, value?: string) => void;
    onClearAll?: () => void;
};

const ManifestFilterTags: React.FC<Props> = ({ tags, ownerId, teamId, createdBy, onClearTag, onClearAll }) => {
    const { ownerName, teamName, creatorName } = useManifestFilterLabels({ ownerId, teamId, createdBy });

    if (!tags.length) {
        return null;
    }

    return (
        <>
            {tags.map((t) => {
                if (t.key === ListManifestsParamKeys.OWNER_ID) {
                    if (!ownerName) return null;

                    return (
                        <StyledTag
                            key={`${t.key}-${t.value}`}
                            closable
                            onClose={(e) => {
                                e.preventDefault();
                                onClearTag(t.key);
                            }}
                        >
                            {ownerName}
                        </StyledTag>
                    );
                }

                if (t.key === ListManifestsParamKeys.TEAM_ID) {
                    if (!teamName) return null;

                    return (
                        <StyledTag
                            key={`${t.key}-${t.value}`}
                            closable
                            onClose={(e) => {
                                e.preventDefault();
                                onClearTag(t.key);
                            }}
                        >
                            {teamName}
                        </StyledTag>
                    );
                }

                if (t.key === ListManifestsParamKeys.CREATED_BY) {
                    if (!creatorName) return null;

                    return (
                        <StyledTag
                            key={`${t.key}-${t.value}`}
                            closable
                            onClose={(e) => {
                                e.preventDefault();
                                onClearTag(t.key);
                            }}
                        >
                            {creatorName}
                        </StyledTag>
                    );
                }

                if (t.key === ListManifestsParamKeys.MANIFEST_STATUSES) {
                    return (
                        <StyledTag
                            key={`${t.key}-${t.value}`}
                            closable
                            onClose={(e) => {
                                e.preventDefault();
                                onClearTag(t.key, t.value);
                            }}
                        >
                            {capitalize(t.value)}
                        </StyledTag>
                    );
                }

                // fallback: plain value
                return (
                    <StyledTag
                        key={`${t.key}-${t.value}`}
                        closable
                        onClose={(e) => {
                            e.preventDefault();
                            onClearTag(t.key, t.value);
                        }}
                    >
                        {t.value}
                    </StyledTag>
                );
            })}

            {onClearAll && (
                <Button type="link" onClick={onClearAll}>
                    Clear All Filters
                </Button>
            )}
        </>
    );
};

export default ManifestFilterTags;
